let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Ju5La")).then(() => parcelRequire('c7rEO'));